










export enum FixedCommentSetTypeEnum {

	Overread = "OVERREAD",

	Technician = "TECHNICIAN",

}